// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboPrices_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combo_prices/salvar.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ComboPrices_SalvarResponseDados {
so_combo_price_id: number
}

export type ComboPrices_SalvarResponse = ApiResponse<ComboPrices_SalvarResponseDados>;

registerResponseContract('ComboPrices_SalvarResponse', {
  so_combo_price_id: { type: 'number',  required: true },
})
